import { PageHeader } from '@/components/PageHeader';

/**
 * Visible "próximamente" placeholder for nav destinations that belong to later
 * vertical slices. Keeps the information architecture complete (no dead links)
 * while making it obvious the screen is not built yet — a composed, on-brand
 * panel rather than an empty page.
 */
export function Placeholder({ title, note }: { title: string; note?: string }) {
  return (
    <div className="flex flex-col gap-6">
      <PageHeader title={title} description="Sección en construcción" />
      <div className="rounded-lg border border-dashed border-border-strong bg-surface px-6 py-16 text-center">
        <span className="mx-auto flex h-12 w-12 items-center justify-center rounded-xl border border-accent/30 bg-accent-soft text-brand-primary">
          <svg
            width="22"
            height="22"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.6"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
          >
            <path d="M3 7l9-4 9 4-9 4-9-4Z" />
            <path d="M3 7v10l9 4 9-4V7" />
            <path d="M12 11v10" />
          </svg>
        </span>
        <span className="mx-auto mt-5 block h-px w-10 bg-brand-accent" aria-hidden="true" />
        <p className="mt-4 text-base font-semibold text-text-primary">Próximamente</p>
        <p className="mx-auto mt-2 max-w-md text-sm text-text-muted">
          {note ??
            'Esta funcionalidad llega en una próxima entrega. La navegación y los permisos por rol ya están definidos.'}
        </p>
      </div>
    </div>
  );
}
